import { $, $$ } from "@/utilities/helpers";

export class FeatureFilter {
    constructor(element) {
        this.element = element;
        this.filters = $$(".js-feature-filter");
        this.activeFilter = $(".js-feature-filter.active").dataset.filter || "all";
        this.issueLookup = this._getIssueLookup();
        this.init();
    }

    init() {
        this._hydrateIssueTemplates();

        // Filter features on load
        this._filterFeatures();

        // Handle filter click
        this._handleFilterClick();
    }

    _filterFeatures() {
        const filter = this.activeFilter;
        const features = $$(".feature");

        features.forEach((feature) => {
            if (feature.dataset.matchedIssue === "0") {
                feature.classList.add("hidden");
                return;
            }

            if (filter === "all") {
                feature.classList.remove("hidden");
                return;
            }

            if (feature.dataset.filter === filter) {
                feature.classList.remove("hidden");
            } else {
                feature.classList.add("hidden");
            }
        });
    }

    _handleFilterClick() {
        this.filters.forEach((filter) => {
            filter.addEventListener("click", () => {
                this.activeFilter = filter.dataset.filter;
                this.filters.forEach((f) => f.classList.remove("active"));

                filter.classList.add("active");
                this._filterFeatures();
            });
        });
    }

    _getIssueLookup() {
        const script = document.getElementById("seo-issue-lookup");

        if (!script || !script.textContent) {
            return null;
        }

        try {
            const parsed = JSON.parse(script.textContent);
            return parsed && typeof parsed === "object" ? parsed : null;
        } catch (error) {
            return null;
        }
    }

    _hydrateIssueTemplates() {
        if (!this.issueLookup) {
            return;
        }

        const features = $$(".feature");

        features.forEach((feature) => {
            const titleElement = feature.querySelector(".feature__title h4");
            if (!titleElement) {
                feature.dataset.matchedIssue = "0";
                feature.classList.add("hidden");
                return;
            }

            const key = this._normalizeIssueName(titleElement.textContent || "");
            const issue = this._findIssueByTitleKey(key);

            if (!issue) {
                feature.dataset.matchedIssue = "0";
                feature.classList.add("hidden");
                return;
            }

            feature.dataset.matchedIssue = "1";
            feature.dataset.filter = issue.filter || "low";

            this._setIssueCounts(feature, issue.urls, issue.percent);
            this._setIssueDescription(feature, issue.description || "");
        });
    }

    _setIssueCounts(feature, urls, percent) {
        const urlsElement = feature.querySelector(".feature__urls");
        if (!urlsElement) {
            return;
        }

        const sparkle = urlsElement.querySelector("i");
        const safeUrls = Number.isFinite(Number(urls)) ? Math.max(0, Math.round(Number(urls))) : 0;
        const safePercent = Number.isFinite(Number(percent)) ? Number(percent).toFixed(1) : "0.0";

        urlsElement.textContent = "";
        if (sparkle) {
            urlsElement.appendChild(sparkle);
            urlsElement.append(` ${safeUrls} URLs | ${safePercent}%`);
            return;
        }

        urlsElement.textContent = `${safeUrls} URLs | ${safePercent}%`;
    }

    _setIssueDescription(feature, description) {
        const fullDescription = `${description}`.trim();
        if (!fullDescription) {
            return;
        }

        const shortDescription = this._shortenDescription(fullDescription, 180);

        const modalDescription = feature
            .querySelector("template")
            ?.content?.querySelector(".features-modal__content__text p");

        if (modalDescription) {
            modalDescription.textContent = fullDescription;
        }

        const inlineDescription = feature.querySelector(".feature__description p");
        if (!inlineDescription) {
            return;
        }

        const currentInlineText = `${inlineDescription.textContent || ""}`.trim();
        if (currentInlineText !== "") {
            return;
        }

        inlineDescription.textContent = shortDescription;
    }

    _shortenDescription(value, limit = 180) {
        const text = `${value}`.replace(/\s+/g, " ").trim();

        if (text.length <= limit) {
            return text;
        }

        const clipped = text.slice(0, limit);
        const lastSpaceIndex = clipped.lastIndexOf(" ");

        if (lastSpaceIndex <= 0) {
            return `${clipped}...`;
        }

        return `${clipped.slice(0, lastSpaceIndex)}...`;
    }

    _normalizeIssueName(value) {
        return `${value}`
            .toLowerCase()
            .trim()
            .replace(/&/g, " and ")
            .replace(/[^a-z0-9]+/g, " ")
            .trim();
    }

    _findIssueByTitleKey(titleKey) {
        if (!titleKey || !this.issueLookup) {
            return null;
        }

        if (this.issueLookup[titleKey]) {
            return this.issueLookup[titleKey];
        }

        const keys = Object.keys(this.issueLookup);

        for (const issueKey of keys) {
            if (issueKey.includes(titleKey) || titleKey.includes(issueKey)) {
                return this.issueLookup[issueKey];
            }
        }

        return null;
    }
}